/** 웹 → 네이티브 메시지 타입 (postMessage) */ export const NATIVE_MESSAGE = {
    LOGIN_REQUEST: "LOGIN_REQUEST",
    NOTIFICATION_PERMISSION_REQUEST: "NOTIFICATION_PERMISSION_REQUEST",
    EVENT_NOTIFICATION_SUBSCRIBE: "EVENT_NOTIFICATION_SUBSCRIBE",
    OPEN_URL: "OPEN_URL",
    DOWNLOAD_REQUEST: "DOWNLOAD_REQUEST",
    NAVIGATE_TAB: "NAVIGATE_TAB"
};
/** NAVIGATE_TAB 메시지의 tab 값 (네이티브 앱 탭 키와 동기화 필요) */ export const NATIVE_TAB = {
    RESOURCES: "ResourcesTab"
};
/** 네이티브 → 웹 이벤트 타입 (CustomEvent detail.type) */ export const NATIVE_EVENT = {
    LOGIN_RESULT: "LOGIN_RESULT",
    LOGOUT_RESULT: "LOGOUT_RESULT",
    NOTIFICATION_PERMISSION_RESULT: "NOTIFICATION_PERMISSION_RESULT",
    EVENT_NOTIFICATION_RESULT: "EVENT_NOTIFICATION_RESULT"
};
